import { useEffect, useState } from "react"

import * as Font from "expo-font"
import { Slot } from "expo-router"

import { DialogContextProvider, ThemeContextProvider } from "wealthmode-frontend/context"
import { Box, GluestackUIProvider, ScrollView, Spinner } from "wealthmode-frontend/gluestack/ui"

import "~/global.css"

import { Config } from "@/Config"
import { useReferralCapture } from "@/lib/referral"

export default function RootLayout() {
  const [loading, setLoading] = useState(true)
  const [colorMode, setColorMode] = useState<"light" | "dark">("light")

  // Runs before the loading gate so a referral link is captured even if the visitor leaves
  // while fonts and config are still resolving.
  useReferralCapture()

  useEffect(() => {
    Promise.all([
      Font.loadAsync({
        BricolageGrotesque: require("~/assets/fonts/BricolageGrotesque.ttf"),
      }),
      Config.load(),
    ])
      .then(() => {
        setLoading(false)
      })
      .catch((err) => {
        console.error("Error loading website config: ", err)
        setLoading(false)
      })

    const urlParams = new URLSearchParams(window.location.href.split("?")[1])
    // const theme = urlParams.get("theme")?.match(/^[A-Za-z0-9\s]+/)?.[0]
    // if (theme && (theme === "light" || theme === "dark")) {
    //   setColorMode(theme)
    //   return
    // }
    // const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
    // setColorMode(prefersDark ? "dark" : "light")

    setColorMode("dark")
  }, [])

  if (loading) {
    return (
      <Box className="bg-background-primary min-h-screen flex items-center justify-center">
        <Spinner size="large" />
      </Box>
    )
  }

  return (
    <ThemeContextProvider theme={colorMode}>
      <GluestackUIProvider mode={colorMode}>
        <DialogContextProvider>
          <ScrollView
            className="flex-1 w-full bg-background-primary"
            contentContainerClassName="min-h-screen w-full flex-grow"
          >
            <Slot />
          </ScrollView>
        </DialogContextProvider>
      </GluestackUIProvider>
    </ThemeContextProvider>
  )
}
